import { React, PropTypes, reduxConnect } from '../lib/imports';

import withTracking from '../decorators/withTracking';
import { ErrorModal } from '../components';
import Layout from '../layout/Layout';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';

const CoreLayout = ({ showFooter, crashError, ...props }) => {
  return (
    <Layout>
      {crashError && <ErrorModal />}
      <Header />
      <Layout.Body>
        <Layout.Wrapper>
          <Content {...props} />
        </Layout.Wrapper>
      </Layout.Body>
      {showFooter && <Footer />}
    </Layout>
  );
};

CoreLayout.propTypes = {
  showFooter: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const { config, routing, onboarding, ui, picks, offers, reminders } = state;
  const { isActive, reminderHasUpdated } = reminders;
  const { routeBase } = config;
  const { isFetching, heatStreakPanelOpen, hasFetchError, fetchErrorCount, crashError } = ui;
  const { onboardingStep, initialStep, correctAnswer, selectedAnswer, quizAttempts } = onboarding;
  const { allRouteIds, routeById, currentRoute } = routing;
  const { randomPicksSelected, picked: playerPicks, picksSubmitted } = picks;
  const { isClicked: isOffersClicked } = offers;
  const { displaySettings } = routeById[currentRoute];

  const initialPage = (hasFetchError && fetchErrorCount < 3) || initialStep >= 3 || onboardingStep >= 4 ? 1 : 0;

  const allRoutes = allRouteIds.map((id) => {
    const route = routeById[id];

    return {
      ...route,
      pageId: id,
    };
  });

  const quizDisabled = !!initialPage;

  const routeFilter = ({ id }) => (!quizDisabled ? id !== 'onboarding' : id !== 'onboarding' && id !== 'playNow');

  return {
    ...displaySettings,
    allRoutes,
    routeBase,
    routeFilter,
    defaultPage: allRoutes[initialPage],
    quizDisabled,
    config,
    onboarding,
    isFetching,
    heatStreakPanelOpen,
    currentRoute,
    correctAnswer,
    selectedAnswer,
    quizAttempts,
    randomPicksSelected,
    playerPicks,
    isOffersClicked,
    picksSubmitted,
    isActive,
    reminderHasUpdated,
    crashError,
  };
};

export default reduxConnect(mapStateToProps)(withTracking(CoreLayout));
